import { Ruler } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useUnits } from "../context/UnitsContext";

export const UnitToggle = ({ compact }) => {
  const { toeUnit, setToeUnit, wheelDia, setWheelDia } = useUnits();
  const { t } = useTranslation();
  const OPTS = [
    { k: "deg", label: t("units.degrees") },
    { k: "in", label: t("units.inches") },
    { k: "mm", label: t("units.mm") },
  ];
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="unit-toggle">
      {!compact && (
        <span className="flex items-center gap-1 font-mono text-[10px] text-slate-500 tracking-widest uppercase">
          <Ruler size={12} className="text-cyan" /> {t("units.toeUnit")}
        </span>
      )}
      <div className="inline-flex rounded-lg bg-ink border border-steel p-0.5">
        {OPTS.map((o) => (
          <button key={o.k} data-testid={`unit-${o.k}`} onClick={() => setToeUnit(o.k)}
            className={`px-2.5 py-1 rounded-md font-mono text-[10px] uppercase tracking-widest transition-colors ${
              toeUnit === o.k ? "bg-cyan text-ink font-bold" : "text-slate-400 hover:text-white"
            }`}>
            {o.label}
          </button>
        ))}
      </div>
      {toeUnit !== "deg" && (
        <label className="flex items-center gap-1.5 font-mono text-[10px] text-slate-400 tracking-wide">
          <span className="uppercase">{t("units.wheel")}</span>
          <input type="number" data-testid="wheel-dia" value={wheelDia}
            onChange={(e) => setWheelDia(e.target.value)} min="10" max="30" step="0.5"
            className="w-14 h-7 text-center rounded-md bg-ink border border-steel text-white focus:outline-none focus:ring-1 focus:ring-cyan" />
          <span>in</span>
        </label>
      )}
    </div>
  );
};
